export default "__VITE_ASSET__CEyLvzhv__"